import React from 'react';
import { FiClock, FiCheckCircle, FiXCircle } from 'react-icons/fi';
import styles from './StatusBadge.module.css';
import { LeadStatus } from '../../types';

const CONFIG: Record<LeadStatus, { label: string; icon: React.ReactNode; cls: string }> = {
  pending: { label: 'Pending', icon: <FiClock />, cls: styles.pending },
  confirmed: { label: 'Confirmed', icon: <FiCheckCircle />, cls: styles.confirmed },
  rejected: { label: 'Rejected', icon: <FiXCircle />, cls: styles.rejected },
};

const StatusBadge: React.FC<{ status: LeadStatus }> = ({ status }) => {
  const cfg = CONFIG[status];
  return (
    <span className={`${styles.badge} ${cfg.cls}`}>
      {cfg.icon} {cfg.label}
    </span>
  );
};

export default StatusBadge;
